import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { RouteDataService } from "../../services/route-data/route-data.service";
import { SessionService } from "../../services/session/session.service";

@Component({
  selector: "app-header-questionnaire",
  templateUrl: "./header-questionnaire.component.html",
  styleUrls: ["./header-questionnaire.component.scss"],
})
export class HeaderQuestionnaireComponent implements OnInit {
  env: any = environment;

  constructor(
    private authService: AuthService,
    private router: Router,
    public routeData: RouteDataService,
    private sessionService: SessionService
  ) {}

  ngOnInit() {}

  logout() {
    this.authService.logout().then(() => {
      this.router.navigate(["/login"]);
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/header-questionnaire/header-questionnaire.component.ts